import request from '@/services/request';
import getError from '@/services/getError';

export async function getOrgTableDataOnlyMag(year) {
  try {
    const res = await request({
      endpoint: `/api/${year}/data/kcptablesDopMag`,
      method: 'get',
    });
    if (res.status === 200) {
      return res.data;
    }
  } catch (e) {
    await getError();
    throw new Error(`error getOrgTableDataOnlyMag` + e);
  }
}
export async function changeOrgTableDataOnlyMag(row, year) {
  try {
    const res = await request({
      endpoint: `/api/${year}/data/kcptables`,
      method: 'post',
      body: row,
    });
    if (res.status === 200) {
      return res.data;
    }
  } catch (e) {
    await getError();
    throw new Error(`error changeOrgTableDataOnlyMag ` + e);
  }
}
export async function deleteOrgTableDataOnlyMag(id, year) {
  try {
    const res = await request({
      endpoint: `/api/${year}/data/kcptables/${id}`,
      method: 'delete',
    });
    if (res.status === 200) {
      return res.data;
    }
  } catch (e) {
    await getError();
    throw new Error(`error deleteOrgTableDataOnlyMag ` + e);
  }
}
